import React from "react";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import PropTypes from "prop-types";

const CustomLinkBase = props => {
  const customCallback = () => {
    props.callback && props.callback();
    props.closeAll();
  };
  return <Link {...props} callback={customCallback} />;
};

const mapDispatchToProps = dispatch => ({
  closeAll: () => dispatch({ type: "CLOSE_ALL" })
});

export const CustomLink = connect(
  () => ({}),
  mapDispatchToProps
)(CustomLinkBase);

CustomLinkBase.propTypes = {
  closeAll: PropTypes.func,
  callback: PropTypes.func
};
